
export const ROUTER_NAMES = {
    RELATORIO_LOG_COMUNICACAO: 'RelatorioLogComunicacao',
    RELATORIO_FORNECEDOR: 'RelatorioFornecedor',
    RELATORIO_COMPRADOR: 'RelatorioComprador',
    RELATORIO_MATCH: 'RelatorioMatch',
    RELATORIO_USUARIO: 'RelatorioUsuario',
    RELATORIO_INSCRICAO_EVENTO: 'RelatorioInscricaoEvento',
}

export default [
    {
        name: ROUTER_NAMES.RELATORIO_LOG_COMUNICACAO,
        path: '/relatorios/logComunicacao',
        meta: {
            title: 'Log de Comunicação'
        },
        component: () => import('@/views/Relatorios/RelatorioLogComunicacao')
    }, 
    {
        name: ROUTER_NAMES.RELATORIO_FORNECEDOR,
        path: '/relatorios/fornecedor',
        meta: {
            title: 'Relatório Fornecedores'
        },
        component: () => import('@/views/Relatorios/Fornecedor')
    },  
    {
        name: ROUTER_NAMES.RELATORIO_COMPRADOR,
        path: '/relatorios/comprador',
        meta: {
            title: 'Relatório Compradores'
        },
        component: () => import('@/views/Relatorios/Comprador')
    },  
    {
        name: ROUTER_NAMES.RELATORIO_MATCH,
        path: '/relatorios/match',
        meta: {
            title: 'Relatório Matchs Realizados'
        },
        component: () => import('@/views/Relatorios/Match')
    },  
    {
        name: ROUTER_NAMES.RELATORIO_USUARIO,
        path: '/relatorios/usuarios',
        meta: {
            title: 'Relatório Usuários'
        },
        component: () => import('@/views/Relatorios/Usuarios')
    },  
    {
        name: ROUTER_NAMES.RELATORIO_INSCRICAO_EVENTO,
        path: '/relatorios/inscricaoEvento',
        meta: {
            title: 'Relatório Inscrição de Eventos'
        },
        component: () => import('@/views/Relatorios/InscricaoEvento')
    },  
]